import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "./title"
import { loadingStatus } from "../../actions"
import { Formik, Field, Form } from "formik"
import * as Yup from "yup"
import fieldStatus from "../../helpers/fieldStatus"
import submitData from "../../helpers/submitData"
import { compose } from "redux"
import { Redirect } from "react-router-dom"
import { toast } from "react-toastify"

class Account extends Component {

	constructor(props) {
		super(props)
		this.state = {
			redirect: false
		}
	}

	validation = () => {
		return Yup.object().shape({
			password: Yup.string()
				.required("Please enter your new password.")
				.matches(
					/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
					"All passwords must be 8 characters and include an uppercase letter, lowercase letter, number, and a special character."
				)
				.required("Password is required."),
			confirm_password: Yup.string()
				.oneOf([Yup.ref("password"), null], "Passwords do not match.")
				.required("Password confirm is required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	render() {
		if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			return (
				<div>
					<Title title="Account" />
					<Formik
						initialValues={{ password: "", confirm_password: "" }}
						validationSchema={this.validation}
						validateOnMount={true}
						onSubmit={(values, { resetForm }) => {
							// check password
							this.props.loadingStatus(true)

							submitData("updatePassword", values).then((resp) => {
								this.props.loadingStatus(false)
								toast.success(resp.message)
								this.setState(
									{
										redirect: true,
										redirectPath: resp.redirect,
									}
								)
							})
						}}
						render={(f) => (
							<div className="sales">
								<div className="content">
									<div className="fullCol">
										<Form>
											<ul className="form__list">
												<li className={fieldStatus("password", f)}>
													<label htmlFor="id">
														Password <sup>*</sup>
													</label>
													{f.errors.password && f.touched.password && (
														<div className="form__message">{f.errors.password}</div>
													)}
													<Field name="password" type="password" className="form__input" />
												</li>
												<li className={fieldStatus("confirm_password", f)}>
													<label htmlFor="closing_price">
														Confirm Password <sup>*</sup>
													</label>
													{f.errors.confirm_password && f.touched.confirm_password && (
														<div className="form__message">{f.errors.confirm_password}</div>
													)}
													<Field
														name="confirm_password"
														type="password"
														className="form__input"
													/>
												</li>
											</ul>
											<input
												type="submit"
												value="Submit"
												className={this.submitClasses(f.isValid)}
											/>
										</Form>
									</div>
									<p className="bg-red-500 py-2 px-4 text-white inline-block rounded-lg font-bold cursor-pointer" onClick={() => {
										localStorage.removeItem('sortPref')
										localStorage.removeItem('columnWidths')
										toast.success('Preferences removed.')
									}}>Remove User Preferences</p>
								</div>
							</div>
						)}
					/>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(Account)
